import type { Icon } from "@tabler/icons-react";

export type CountryCode = "NG" | "GH" | "ZA" | "EG";

export interface Country {
  code: CountryCode;
  name: string;
  flagEmoji: string;
  currencyCode: string;
  currencySymbol: string;
}

export interface ComplianceService {
  id: string;
  name: string;
  description: string;
  icon: Icon;
}

export interface BusinessTypeOption {
  id: string;
  name: string;
}

export type ICompanyDetails = {
  company_name: string;
  business_type: string;
  company_address: string;
  contact_email: string;
  contact_phone: string;
  share_capital: string;
  num_directors: number;
  business_activity: string;
};

export const emptyCompanyDetails: ICompanyDetails = {
  company_name: "",
  business_type: "",
  company_address: "",
  contact_email: "",
  contact_phone: "",
  share_capital: "",
  num_directors: 0,
  business_activity: "",
};

export interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
}

export type WizardStepId = "country" | "company" | "ai" | "generate";

export interface WizardStep {
  id: WizardStepId;
  label: string;
}
